import api from "./base-api"

const cmUserApi = api.injectEndpoints({
    endpoints: (build) => ({
        getCmUsers: build.query({
            query: ({ userId, depth = 0 }) => `v2/cm/users/${userId}?depth=${depth}`
        }),
        searchCmUserIds: build.query({
            query: ({
                sTransactionId = ""
            }) => `v2/cm/users/search?sTransactionId=${sTransactionId}`
        })
    })
})

export const {
    useGetCmUsersQuery,
    useSearchCmUserIdsQuery
} = cmUserApi
